// Paket taslak şeridi (DR4 — SetChangesBar kalıbı): ağacın altına yapışık "N ekleme · M çıkarma ·
// K varsayılan" + Vazgeç / Kaydet (44 px, DR16). Sayaç `aria-live` (DR17-7); kayıt sürerken pasif.

import type { DraftCounts } from "../../lib/kpi-package-draft";
import { KPI_PACKAGES_COPY } from "../../lib/kpi-packages-copy";
import { decisionText, footerBtn } from "./kpi-form-styles";

const C = KPI_PACKAGES_COPY.page;

export function PackageDraftBar(p: {
  counts: DraftCounts;
  /** taslak öncesi / sonrası gösterge sayısı */
  from: number;
  to: number;
  saving: boolean;
  /** kayıt engelli (409 bandı açık) */
  blocked?: boolean;
  onSave: () => void;
  onDiscard: () => void;
}): JSX.Element {
  const { counts } = p;
  return (
    <div
      role="region"
      aria-label={C.draftLabel}
      data-testid="package-draft-bar"
      className="flex flex-wrap items-center gap-2 rounded-xl"
      style={{
        position: "sticky",
        bottom: 8,
        zIndex: 5,
        marginTop: 12,
        padding: "10px 12px",
        background: "var(--color-surface)",
        border: "1px solid var(--color-primary)",
        boxShadow: "var(--shadow-md, 0 8px 24px rgba(15,42,82,.16))",
      }}
    >
      <span aria-live="polite" style={{ ...decisionText, fontWeight: 600 }}>
        {KPI_PACKAGES_COPY.draft.summary(
          counts.added,
          counts.removed,
          p.from,
          p.to,
          counts.defaults,
        )}
      </span>
      <span style={{ flex: 1 }} />
      <button type="button" style={footerBtn()} onClick={p.onDiscard} disabled={p.saving}>
        {C.cancel}
      </button>
      <button
        type="button"
        style={footerBtn(true)}
        onClick={p.onSave}
        disabled={p.saving || p.blocked === true}
        aria-busy={p.saving || undefined}
      >
        {p.saving ? C.saving : C.save}
      </button>
    </div>
  );
}
